// extracted by mini-css-extract-plugin
module.exports = {"date":"styles_date__3dEp_","value":"styles_value__23Iab","rate":"styles_rate__3KNkJ","increment":"styles_increment__3KyvJ","decrement":"styles_decrement__itbzD"};